import { createContext, useContext } from 'react';

/**
 * Size class of the screen the app is rendered into, like SwiftUI's horizontalSizeClass and
 * Compose's WindowSizeClass. Compact: one pane with a tab bar. Wide: sidebar plus two panes.
 */
export interface SizeClass {
  wide: boolean;
  width: number;
  platform: 'ios' | 'macos' | 'windows';
}

export const SizeContext = createContext<SizeClass>({ wide: false, width: 393, platform: 'ios' });

export function useWide(): boolean {
  return useContext(SizeContext).wide;
}

export function useSizeClass(): SizeClass {
  return useContext(SizeContext);
}
